import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemDefaultSettingsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-default-settings',
	path: '/secure/admin/ViewUserDefaultSettings([!%]?[\\w]*).jspa',
};
